import { render } from "./UpdateClientModal.vue?vue&type=template&id=6c0f72e8&scoped=true"
import script from "./UpdateClientModal.vue?vue&type=script&lang=js"
export * from "./UpdateClientModal.vue?vue&type=script&lang=js"

import "./UpdateClientModal.vue?vue&type=style&index=0&id=6c0f72e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c0f72e8"]])

export default __exports__